import Dashboard from './Dashboard'
import '../../../../utils/i18n'

export default Dashboard
